import { baseApi, API_TAGS, createCacheTags, createEndpointBuilder, type Params } from '@/shared/api';

import type { ReceiveLossInfiniteQueryArgs, ReceiveLossPageResponse } from '../model/losses-types';

const receiveEndpoint = createEndpointBuilder('/api/v2/receive');

/**
 * Lost or Not Sent Items list endpoint (`GET /api/v2/receive/losses`). Covers
 * Lost (L) and Never-arrived (N) movements on received shipments, scoped to the
 * active site. Same filters/sorting shape as receive history. Lives in its own
 * `injectEndpoints` call so the losses slice stays self-contained next to the
 * dashboard/history endpoints.
 */
export const receiveLossesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getReceiveLosses: builder.infiniteQuery<ReceiveLossPageResponse, ReceiveLossInfiniteQueryArgs, number>({
      infiniteQueryOptions: {
        initialPageParam: 0,
        getNextPageParam: (lastPage, _allPages, lastPageParam) => {
          const nextPage = lastPageParam + 1;
          if (nextPage >= lastPage.totalPages) {
            return undefined;
          }
          return nextPage;
        }
      },
      query: ({ queryArg, pageParam }) => ({
        url: receiveEndpoint('/losses'),
        params: {
          ...queryArg,
          page: pageParam
        }
      }),
      providesTags: (_result, _error, { queryArg }) =>
        createCacheTags({
          baseTag: API_TAGS.RECEIVE,
          params: queryArg as unknown as Params
        })
    })
  })
});

export const { useGetReceiveLossesInfiniteQuery } = receiveLossesApi;
